import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Outlet } from 'react-router-dom';
import logo from './logo.png';
import './App.css';

import Gainers from './Gainers';
import HighRelativeVolume from './HighRelativeVolume';
import MostActives from './MostActives';
import RegisterUser from './RegisterUser';
import Layout from './Layout';
import LoginForm from './LoginForm';
import { AuthProvider } from './AuthContext';
import TickerDetailPage from './TickerDetail'
import QualityStocks from './QualityStocks';
import SmallCapLeaders from './SmallCapLeaders';
import PositionSizeCalculator from './PositionSizeCalculator';
import IposWithinOneYear from './IposWithinOneYear';
import NewSymbols from './NewSymbols';
import Hvc from './Hvc';
import Rsp from './Rsp';
import IndustryGainers from './IndustryGainers';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/gainers" element={<Gainers />} />
            <Route path="/" element={<Hvc />} />
            <Route path="/most-active" element={<MostActives />} />
            {/* <Route path="/register" element={<RegisterUser />} /> */}
            {/* <Route path="/login" element={<LoginForm />} /> */}
            <Route path="/ticker/:symbol" element={<TickerDetailPage />} />
            <Route path="/qualityStocks" element={<QualityStocks />} />
            <Route path="/smallCapLeaders" element={<SmallCapLeaders />} />
            {/* <Route path="/positionSizeCalculator" element={<PositionSizeCalculator />} />
            <Route path="/iposWithinOneYear" element={<IposWithinOneYear />} />
            <Route path="/newSymbols" element={<NewSymbols />} /> */}
            <Route path="/hvc" element={<Hvc />} />
            <Route path="/relativePerformanceIncreases" element={<Rsp />} />
            {/* <Route path="/sectorIndustryGainers" element={<IndustryGainers />} /> */}



          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
